<template lang="pug">
.c-separator(:class="[chatSeparatorClass, chatFixedClass]" @click="emitClick")
  span.u-txt--fair.c-separator__text {{ separatorText }}
</template>

<script>
import { humanizeTimestamp } from '~/utils/date-helper';

export default {
  name: 'ChatSeparator',
  props: {
    isRead: {
      type: Boolean,
      default: true,
    },
    timestamp: {
      type: Number,
      default: 0,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    chatSeparatorClass() {
      return `c-separator--${this.isRead ? 'read' : 'unread'}`;
    },
    chatFixedClass() {
      return this.isFixed ? 'c-separator--fixed' : '';
    },
    separatorText() {
      if (this.text) return this.text;
      if (!this.isRead) return 'Pesan Baru';
      let yesterday = new Date();
      yesterday = yesterday.setDate(yesterday.getDate() - 1);
      const chatDate = new Date(this.timestamp).toDateString();
      if (chatDate === yesterday && this.isRead) {
        return 'Kemarin';
      }
      return humanizeTimestamp(this.timestamp, '%day%, %dd% %month%');
    },
  },
  methods: {
    emitClick() {
      if (!this.isRead) {
        this.$emit('onReadNewMessage');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.c-separator {
  display: block;
  margin-bottom: 16px;
  padding: 8px;
  text-align: center;

  &--read {
    background-color: #f5f5f5;
  }

  &--unread {
    background-color: #fff7e2;

    .c-separator__text {
      color: #8b6f32;
    }
  }

  &__text {
    font-size: 14px;
    font-weight: 600;
    color: #999999;
  }

  &--fixed {
    position: fixed;
    bottom: 60px; // need to auto calculate this
    left: 0;
    right: 0;
    margin: 0;
  }
}
</style>
